import axios from "axios";

type UnknownRecord = Record<string, unknown>;

function isRecord(value: unknown): value is UnknownRecord {
  return typeof value === "object" && value !== null;
}

/**
 * Normalize API errors (Axios / network / backend `{ error: string }`) into a safe user-facing message.
 */
export function getApiErrorMessage(error: unknown, fallback = "Произошла ошибка"): string {
  if (axios.isAxiosError(error)) {
    // Server responded with a payload
    const serverError = error.response?.data;
    if (typeof serverError === "string" && serverError.trim()) return serverError;
    if (isRecord(serverError)) {
      const maybeError = serverError.error;
      if (typeof maybeError === "string" && maybeError.trim()) return maybeError;
      const maybeMessage = serverError.message;
      if (typeof maybeMessage === "string" && maybeMessage.trim()) return maybeMessage;
    }

    // Request made but no response (offline, CORS, timeout, DNS, etc.)
    if (error.request) return "Нет ответа от сервера. Проверьте подключение и попробуйте снова.";

    if (typeof error.message === "string" && error.message.trim()) return error.message;
  }

  if (error instanceof Error && error.message.trim()) return error.message;
  return fallback;
}

